import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProductImage from "./ProductImage";
import { t } from "../i18n/translations";
import "./CartSummarySidebar.css";

/* Desktop-only, read-only cart summary — sits to the right of the menu
   (ProductScreen.css: `.menu-layout`) so it stays visible while scrolling.
   All cart mutation (qty/remove) still happens only in CartScreen/
   ProductDetailScreen; this just recaps + links to /cart, same as the
   mobile cart-fab it sits alongside. */
function CartSummarySidebar({ table }) {
  const navigate = useNavigate();
  const { cartItems } = useSelector((state) => state.cart);
  const { language } = useSelector((state) => state.language);
  const { restaurant = {} } = useSelector((state) => state.restaurantDetails || {});
  const hidePrices = restaurant.hide_prices === true;

  if (cartItems.length === 0) return null;

  const totalQty = cartItems.reduce((acc, item) => acc + item.qty, 0);
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.qty,
    0,
  );

  return (
    <aside className="cart-sidebar">
      <h2 className="cart-sidebar-title">{t("yourCart", language)}</h2>

      <div className="cart-sidebar-items">
        {cartItems.map((item) => (
          <div key={item.product} className="cart-sidebar-item">
            <ProductImage
              src={item.image}
              alt={item.name}
              className="cart-sidebar-item-image"
            />

            <div className="cart-sidebar-item-info">
              <span className="cart-sidebar-item-name">{item.name}</span>

              {item.selectedOptions?.length > 0 && (
                <div className="cart-sidebar-item-options">
                  {item.selectedOptions.map((opt, idx) => (
                    <div key={idx} className="cart-sidebar-item-option">
                      {opt.name}
                    </div>
                  ))}
                </div>
              )}

              <span className="cart-sidebar-item-qty">×{item.qty}</span>
            </div>

            {!hidePrices && (
              <span className="cart-sidebar-item-price">
                {item.price * item.qty} Ft
              </span>
            )}
          </div>
        ))}
      </div>

      {!hidePrices && (
        <div className="cart-sidebar-total">
          <span>{t("total", language)}</span>
          <span>{totalPrice} Ft</span>
        </div>
      )}

      <button
        type="button"
        className="cart-sidebar-checkout-btn"
        onClick={() => navigate(table ? `/cart?table=${table}` : "/cart")}
      >
        <span>{t("viewCart", language)}</span>
        <span className="cart-sidebar-checkout-count">{totalQty}</span>
      </button>
    </aside>
  );
}

export default CartSummarySidebar;
